import React from 'react';
import { Modal, Button, Row, Col, Spinner } from 'react-bootstrap';
import { FaEdit, FaTrash, FaDownload, FaPaperclip } from 'react-icons/fa';
import { formatarData } from './InformacoesTab';

const ModalVisualizarInformacao = ({
    show,
    onHide,
    informacao,
    empreendimentos,
    codigoUsuarioLogado,
    onEditar,
    onExcluir,
    anexos = [],
    loadingAnexos = false,
    onDownloadAnexo
}) => {
    if (!informacao) return null;

    const emp = empreendimentos.find(e => e.codigo_familia == informacao.codigo_familia);

    const handleDownload = async (anexo) => {
        try {
            await onDownloadAnexo(anexo.codigo, anexo.nome_arquivo);
        } catch (error) {
            console.error('Erro ao baixar anexo:', error);
        }
    };

    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton className="border-0 pb-0">
                <div className="mb-3">
                    <small className="text-muted">
                        {informacao.nome_usuario} - {formatarData(informacao.data)}
                    </small>
                </div>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col md={informacao.codigo_familia ? 8 : 12}>
                        <h5 className="font-weight-bold">{informacao.titulo}</h5>
                        {informacao.assunto && (
                            <p className="mb-3"><strong>Assunto:</strong> {informacao.assunto}</p>
                        )}
                        {informacao.descricao && (
                            <p style={{ whiteSpace: 'pre-wrap' }}>{informacao.descricao}</p>
                        )}
                        {informacao.link && (
                            <p className="mb-2">
                                <strong>Link:</strong>{' '}
                                <a href={informacao.link} target="_blank" rel="noopener noreferrer">
                                    {informacao.link}
                                </a>
                            </p>
                        )}

                        <div className="mt-3">
                            <strong><FaPaperclip className="mr-1" />Anexos:</strong>
                            {loadingAnexos ? (
                                <div className="mt-2">
                                    <Spinner animation="border" size="sm" /> Carregando...
                                </div>
                            ) : anexos.length > 0 ? (
                                <ul className="list-unstyled mt-2">
                                    {anexos.map((anexo) => (
                                        <li key={anexo.codigo} className="mb-2">
                                            <Button
                                                variant="link"
                                                className="p-0 text-primary"
                                                onClick={() => handleDownload(anexo)}
                                            >
                                                <FaDownload className="mr-1" />
                                                {anexo.nome_arquivo}
                                            </Button>
                                        </li>
                                    ))}
                                </ul>
                            ) : (
                                <p className="text-muted mt-2 mb-0">Nenhum anexo</p>
                            )}
                        </div>
                    </Col>
                    {informacao.codigo_familia && (
                        <Col md={4} className="text-center">
                            {emp && (emp.imagem_capa || emp.imagem_principal) && (
                                <img
                                    src={emp.imagem_capa || emp.imagem_principal}
                                    alt={informacao.empreendimento}
                                    className="img-fluid mb-2 rounded"
                                    style={{ maxHeight: '150px', objectFit: 'cover' }}
                                />
                            )}
                            <p className="mb-0"><strong>Empreendimento:</strong></p>
                            <p>{informacao.empreendimento}</p>
                        </Col>
                    )}
                </Row>
            </Modal.Body>
            <Modal.Footer>
                {codigoUsuarioLogado && informacao.codigo_usuario == codigoUsuarioLogado && (
                    <>
                        <Button
                            variant="outline-primary"
                            onClick={() => {
                                onHide();
                                onEditar(informacao);
                            }}
                        >
                            <FaEdit className="mr-1" /> Editar
                        </Button>
                        <Button
                            variant="outline-danger"
                            onClick={() => {
                                onHide();
                                onExcluir(informacao);
                            }}
                        >
                            <FaTrash className="mr-1" /> Excluir
                        </Button>
                    </>
                )}
            </Modal.Footer>
        </Modal>
    );
};

export default ModalVisualizarInformacao;
